import { matchRoutes, RouteObject, useLocation, useRoutes } from 'react-router';

import { useHeaderSection } from '@/common/hooks/useHeaderSection/useHeaderSection';

import { getHeaderSectionByRouteMatches } from './AppRoutes.utils';

interface AppRoutesProps {
  routes: RouteObject[];
}

function AppRoutes(props: AppRoutesProps) {
  const { routes } = props;
  const location = useLocation();

  useHeaderSection(getHeaderSectionByRouteMatches(matchRoutes(routes, location)));

  return useRoutes(routes);
}

export default AppRoutes;
